export default [{
  path: '/admin/apply/BigDataScreen',
  name: 'ApplyBigDataScreen',
  component: () => import('@/views/apply/device/bigDataScreen'),
  meta: {
    title: '数据大屏',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/scmConfig',
  name: 'scmConfig',
  component: () => import('@/views/apply/device/scmConfig'),
  meta: {
    title: '供应链配置',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/selectionStore',
  name: 'selectionStore',
  component: () => import('@/views/apply/device/selectionStore'),
  meta: {
    title: '入库中心',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/deviceType',
  name: 'deviceType',
  component: () => import('@/views/apply/device/deviceType'),
  meta: {
    title: '设备分类',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/deviceList',
  name: 'deviceList',
  component: () => import('@/views/apply/device/deviceList'),
  meta: {
    title: '设备列表',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/deviceAlarm',
  name: 'deviceAlarm',
  component: () => import('@/views/apply/device/deviceAlarm'),
  meta: {
    title: '报警记录',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/screenConfig',
  name: 'screenConfig',
  component: () => import('@/views/apply/device/screenConfig'),
  meta: {
    title: '大屏设置',
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/device.js